module.exports = __webpack_public_path__ + "static/logo-meiquer-aguilas-a5ac36e174419cccd695938203d7b3b3.png";